export const getHexColor = (colorString: string) => {
    if (colorString?.[0] !== "#") {
        return `#${colorString}`;
    }
    return colorString;
};
